import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DataBagService } from 'src/app/common/data-bag.service';
import { ProductService } from '../product.service';

@Component({
	selector: 'app-product-additional',
	templateUrl: './product-additional.component.html',
	styleUrls: ['./product-additional.component.css'],
})
export class ProductAdditionalComponent implements OnInit {
	@Input() editable = true;
	protected additionalCharge = false;

	constructor(
		public service: ProductService,
		public bag: DataBagService,
	) {}
	ngOnInit(): void {
		if (this.service.data.surchargeBoard && this.service.data.surchargeBoard.fee != 0) {
			this.additionalCharge = true;
		}

		this.bag.get('/board/?limit=9999', (result, error) => {
			this.service.mockData.board = result.results;
		});
		this.bag.get('/transport/stop/?stop_type=TG,DO&limit=9999', (result, error) => {
			this.service.mockData.stops = result.results;
		});
		this.bag.get('/product/convenience/?limit=999', (result, error) => {
			this.service.mockData.convenience = result.results;
		});
		this.bag.get('/currency/', (result, error) => {
			this.service.mockData.currency = result.results;
		});
	}
	changeState() {
		this.additionalCharge = !this.additionalCharge;
	}
	convertPriceToGrosze(price) {
		return price * 100;
	}
}
